module.exports = __webpack_public_path__ + "static/lamp-328c935d89250ddd7f49d743a7d4a9b2.png";